
/**
 *
 * 复制文本
 * tzw 2022年9月14日15:41:52
 *
 * @param {string} text 需要复制的文本信息
 * @returns
 */
function copy(text) {
    if (!document) {
        return console.error('document is not defined')
    }

    let text_area = document.createElement('textarea')
    document.body.appendChild(text_area)
    text_area.value = text
    text_area.select()
    const res = document.execCommand('copy')
    // 谨慎点，异步操作
    setTimeout(() => text_area.remove(), 0)
    return res
}

/**
 * 加载图片
 *
 */
function loadImage(src) {
    return new Promise((resolve, reject) => {
        // 创建一个img标签
        const imgDom = new Image();
        imgDom.src = src;
        // 图片加载完成使用正常的图片
        imgDom.onload = function () {
          resolve(src)
        }
        // 图片加载失败使用图片占位符
        imgDom.onerror = function (err) {
          reject(err)
        }
    })
}

/**
 * 价格计算
 * @param {int} number 价格数值（单位：分）
 * @param {int} decimal_count 保留小数（默认0, 最大是2）
 */
function mathPrice(number, decimal_count = 0) {
    if (!number) {
        return 0
    }

    if (decimal_count < 0) decimal_count = 0
    if (decimal_count > 2) decimal_count = 2

    if (decimal_count === 0) {
        return number / 100
    }

    let number_str = number.toString()

    let left,right;
    // 如果是2位数
    if (number_str.length < 3) {
        left = '0'
        if (number_str.length === 2) {
            right = number_str
        }

        if (number_str.length === 1) {
            right = `0${number_str}`
        }
    } else {
        left = number_str.slice(0, number_str.length - 2)
        right = number_str.slice(number_str.length - 2)
    }

    return `${left}.${right.slice(0, decimal_count)}`
}

// 数字转中文
function NoToChinese(num) {
    if (!/^\d*(\.\d*)?$/.test(num)) {
        alert("Number is wrong!");
        return "Number is wrong!";
    }
    var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
    var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
    var a = ("" + num).replace(/(^0*)/g, "").split("."),
        k = 0,
        re = "";
    for (var i = a[0].length - 1; i >= 0; i--) {
        switch (k) {
            case 0:
                re = BB[7] + re;
                break;
            case 4:
                if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                    re = BB[4] + re;
                break;
            case 8:
                re = BB[5] + re;
                BB[7] = BB[5];
                k = 0;
                break;
        }
        if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
        if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
        k++;
    }
    if (a.length > 1) //加上小数部分(如果有小数部分)
    {
        re += BB[6];
        for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
    }
    if(re == '一十') return '十'
    return re;
};

export function isOnlineByHostname(){
  return ['www.zhumavip.com', 'www.zhongheschool.com', 'zhumavip.com', 'zhongheschool.com'].includes(window.location.hostname)
}

export  function sentryLog(response){
  try {
    const userInfo = JSON.parse(localStorage.getItem('react_user_info'))
    console.warn(`url: ${response.config.baseURL}${response.config.url}
             userId:${userInfo?.userId || '无'}
             mobile：${userInfo?.mobile || '无'}
            token：${userInfo?.token || '无'}
             params:${JSON.stringify(response.config.data) || JSON.stringify(response.config?.params) || ''}
             返回数据：${JSON.stringify(response?.data)}`)
  }catch (e) {

  }
}
export default {
    copy,
    loadImage,
    mathPrice,
    NoToChinese
}
